import {
  EntityMultiSelect, Form, Link, Text,
} from '@domain-group/suit-theme'

import usePublications from '@hooks/usePublications'
import { useDebounce, useSetState } from '@domain-group/react-hooks'

import useAgencies from '@hooks/useAgencies'
import useCreateAgencyPublicationsModal from '../hooks/useCreateAgencyPublicationsModal'

const defaultState = {
  string: '',
}

type SelectPublicationsProps = {
  createAgencyPublicationPayload: ReturnType<typeof useCreateAgencyPublicationsModal>,
}

const SelectPublications = (props: SelectPublicationsProps) => {
  const { createAgencyPublicationPayload } = props

  const [state, setState] = useSetState(defaultState)
  const { string } = state

  const debouncedString = useDebounce(string, 300)

  const {
    agency,
    callbacks: {
      createOrEditAgencyProvider,
      setSelectedPublicationIds,
    },
    publications,
    selectedPublicationIds,
  } = createAgencyPublicationPayload

  const publicationsPayload = usePublications({
    filters: {
      // @ts-expect-error TS2561
      provider_assigned_agency_id: agency.id,
      // @ts-expect-error TS2339
      provider_ids: agency.assigned_provider_ids,
      string: debouncedString,
    },
    performHttpRequests: true,
  })

  // We need to filter by assigned provider but returning all agency_ids could be a huge array
  // So we load the agency again including the assigned provider_ids
  useAgencies({
    // @ts-expect-error TS2353
    filters: { agency_ids: [agency.id] },
    // @ts-expect-error TS2339
    performHttpRequests: !!agency.id,
    requestOptions: { include_agency_assigned_provider_ids: true },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredPublications,
    filteredPublicationsCount,
    loading,
  } = publicationsPayload

  const filteredPublicationIds = filteredPublications.map(publication => publication.id)

  return (
    <>
      <Form.Field label="Search Publications">
        <input onChange={e => setState({ string: e.target.value })} value={string} />
      </Form.Field>

      <EntityMultiSelect
        boxProps={{ height: '80%', marginTop: 'large' }}
        callbacks={{
          loadMore,
          // @ts-expect-error TS2322
          setSelectedIds: setSelectedPublicationIds,
        }}
        canLoadMore={canLoadMore}
        entities={publications}
        entityCount={filteredPublicationsCount}
        filteredEntityIds={filteredPublicationIds}
        loading={loading}
        selectedIds={selectedPublicationIds}
      />

      <Text color="faintGrey" fontSize="xsmall" marginTop="large">
        Can&apos;t find what you&apos;re looking for? Assign another provider&nbsp;
        <Link onClick={() => createOrEditAgencyProvider()}>here</Link>
      </Text>
    </>
  )
}

export default SelectPublications
